import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Inject } from "vue-property-decorator";

@Component
export default class DataCellBase extends Vue {
  @Inject()
  protected bus: Vue;

  @Prop()
  protected props!: ITableRowProps;

  @Prop()
  protected header!: IProp;

  @Prop()
  protected rowOptions: { [key: string]: ITableRowOption };

  protected get value() {
    if (this.props.item) {
      return this.props.item[this.header.value];
    }
  }

  protected get cellOptions(): ITableRowOption | undefined {
    if (this.rowOptions) {
      let opt = this.rowOptions[this.header.value];
      return opt;
    }
    return undefined;
  }

  protected get alertType() {
    if (this.cellOptions) {
      return this.cellOptions.alertType;
    }
    return this.header.alertType;
  }

  protected get color() {
    if (this.cellOptions) {
      return this.cellOptions.color;
    }
    if (this.header.color) {
      return this.header.color;
    }
    return undefined;
  }

  protected get options(): ITableRowOption | undefined {
    if (this.cellOptions) {
      let opt = this.cellOptions[this.header.value];
      if (opt) {
        return opt;
      }
    }
    return undefined;
  }
}
